import { Datalayer, DatalayersMap, defineDirective, FieldViewModel, IOmniaShell, isObject, LayerTypeId, LayerViewModel, sum } from "../omnia"
import { IDatalayersService, ILayerDetailsScope } from "../types"

export class LayerDetailsCtrl {

    static create(): ng.IDirective {
        return defineDirective(LayerDetailsCtrl, "app/datalayers/details/details.html");
    };

    map: DatalayersMap

    private layerWatcher: Function

    public field: FieldViewModel

    public layer: Datalayer
    public supportedLayer: boolean

    public yieldLayer: Datalayer
    public perfLayer: Datalayer
    public terramapLayer: Datalayer

    public layerName: string

    public totalYield?: number
    public avgYield?: number

    public totalCarbon?: number
    public avgCarbon?: number

    public layerViewModel: LayerViewModel

    public visible: boolean

    static $inject = ["$scope", "OmniaDatalayersService", "OmniaShell"];

    constructor(private $scope: ng.IScope, private svc: IDatalayersService, private shell: IOmniaShell) {
    }

    $onInit() {

        const parentScope = <ng.IScope & ILayerDetailsScope>this.$scope.$parent
        const { context, setVisibility } = parentScope

        this.$scope.$watch(() => context.getSelectedField(), f => {

            this.field = f

            if (this.layerWatcher) {
                this.layerWatcher()
            }

            this.layerWatcher = this.$scope.$watch(() => f ? context.map.getTopmostLayer(l => l.fieldId == f.fieldId) : null, layer => {

                this.layer = layer
                this.layerName = undefined

                this.yieldLayer = layer && (layer.typeId == LayerTypeId.Yield) ? layer : null
                this.perfLayer = layer && (layer.typeId == LayerTypeId.YieldFieldPerformance) ? layer : null
                this.terramapLayer = isSupportedTerramapLayer(layer)

                this.supportedLayer = !!(this.yieldLayer || this.perfLayer || this.terramapLayer)

                this.layerName = (this.yieldLayer || this.perfLayer)?.description

                this.visible = this.supportedLayer

                this.layerViewModel = layer ? context.layers.find(l => l.datalayerId == layer.datalayerId) : null

                this.totalYield = this.yieldLayer ? getTotalYield(this.yieldLayer) : null
                this.avgYield = this.yieldLayer ? calculateAvgYield(this.yieldLayer, this.totalYield) : null

                const carbon = this.terramapLayer ? getTerramapTotal(this.terramapLayer) : null
                this.totalCarbon = carbon?.total
                this.avgCarbon = carbon?.average

                if (setVisibility) {
                    setVisibility(this.visible)
                }

            })

        })
    }

}

function getTotalYield(layer: Datalayer) {

    const data = layer.datalayer

    const value = data.Value ? parseFloat(String(data.Value)) : null

    const totalYield = (value != null)
        ? value
        : calculateTotalYield(layer)

    return totalYield

}

function calculateTotalYield(layer: Datalayer) {
    const total = layer.zones.reduce((y, z) => y + (Number(z.value) * z.area), 0)
    const rounded = Math.round(total / 100) / 100
    return rounded
}

function calculateAvgYield(layer: Datalayer, total: number) {
    const totalArea = sum(layer.zones, z => z.area) / 10000
    return Math.round((total / totalArea) * 100) / 100
}

function getTerramapTotal(layer: Datalayer) {

    const points = layer.datalayer.Points

    if (isObject(points) && points.Sum) {

        const totalArea = layer.zones.reduce((area, zone) => area + zone.area, 0)

        const average = (points.Sum / points.Count)
        const total = average * (totalArea / 10000)

        return {
            total: Math.round(total * 100) / 100,
            average: Math.round(average * 100) / 100
        }

    }

}

function isSupportedTerramapLayer(layer: Datalayer) {

    switch (layer?.typeId) {

        case LayerTypeId.ActiveCarbonTHa:
        case LayerTypeId.OrganicCarbonTHa:
            return layer

    }

}
